import { CustomerAction } from './customer-action';
import { CustomerActionKey, ICustomerStore } from './customer-type';

export const customerReducer = (
  state: ICustomerStore = DEFAULT_STATE,
  action: CustomerAction
): ICustomerStore => {
  switch (action.type) {
    case CustomerActionKey.SetCustomers:
      return {
        ...state,
        customers: action.payload.customers
      };

    default:
      return state;
  }
};

const DEFAULT_STATE: ICustomerStore = {
  customers: []
};



// WEBPACK FOOTER //
// ./src/modules/customers/parts/customer-reducer.ts